module.exports = __webpack_public_path__ + "img/insurance-card-supp.fd9fddb.png";